
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { 
    init,
    loadTranferPayment,
} from '../../modules/payment/payment'


import AdminClubCoupon from '../../components/admin/AdminClubCoupon';
import AdminClubBarcode from '../../components/admin/AdminClubBarcode';
import client, { url } from '../../lib/api/client';
import qs from 'qs';
import { loadAllClubList } from '../../modules/clubs/clubs';
import ClubSelectItem from '../../components/admin/ClubSelectItem';
import ClubCreateModal from '../../components/admin/ClubCreateModal';
import AdminClubRunningTrack from '../../components/admin/AdminClubRunningTrack';
import AdminClubDoorInfo from '../../components/admin/AdminClubDoorInfo';
import AdminClubStatusInfo from '../../components/admin/AdminClubStatusInfo';
import AdminClubRegistNumberInfo from '../../components/admin/AdminClubRegistNumberInfo';
import AdminClubDataInfo from '../../components/admin/AdminClubDataInfo';
import AdminClubKioskInfo from '../../components/admin/AdminClubKioskInfo';
import AdminClubTypeInfo from '../../components/admin/AdminClubTypeInfo';
import AdminClubAttendAppInfo from '../../components/admin/AdminClubAttendAppInfo';
import { changePassword, clubMemberRegist } from '../../lib/api/auth';
import { saleMembership, updateMembership } from '../../lib/api/membership';
import { list } from '../../lib/api/item';
import { addClubUserLocker, readClubLocker } from '../../lib/api/locker';
import { loadClubMemberList } from '../../lib/api/search';
import { read_membership } from '../../lib/api/member';

const SettingsLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 40px;
`;

const AdminClubSettingContainer = ({history}) => {

    const dispatch = useDispatch();
    const {
      user,
      socketKey,
      clubs,
    } = useSelector(({ user, socket, payment, clubs }) => ({
        user: user.user,
        socketKey: socket.socketKey,
        clubs: clubs.clubs,
    }));
    
    const [clubCreateModalOpen, setClubCreateModalOpen] = useState(false)
    const [clubList, setClubList] = useState("")
    const [selectClub, setSelectClub] = useState(0)
    const [selectClubInfo, setSelectClubInfo] = useState(null)
    
    // CSV 파일 상태 관리
    const [memberFileInfo, setMemberFileInfo] = useState(null)
    const [membershipFileInfo, setMembershipFileInfo] = useState(null)
    const [lockerFileInfo, setLockerFileInfo] = useState(null)
    
    // 업데이트 진행상황 관리
    const [updateProgress, setUpdateProgress] = useState({
        isProcessing: false,
        totalCount: 0,
        completedCount: 0,
        currentFile: '',
        fileProgress: {
            member: { total: 0, completed: 0 },
            membership: { total: 0, completed: 0 },
            locker: { total: 0, completed: 0 }
        }
    })

    useEffect(() => {
        let _clubList = [];
        if(clubs && clubs.length > 0) {
            for (let i = 0; i < clubs.length; i++) {
                _clubList.push({
                    label:clubs[i].name, value:clubs[i].clubID
                })
                
            }
        }
        setClubList(_clubList)
    }, [clubs])

    useEffect(() => {
        _resetClubInfo(selectClub)
    }, [selectClub])

    const _resetClubInfo = async (clubid)=>{
        const _clubid = parseInt(clubid)
        console.log('111 : ', _clubid, clubs)
        if(_clubid == 0) {
            return;
        }
        console.log('2222 : ', _clubid, clubs)

        // 파일 상태 초기화
        setMemberFileInfo(null)
        setMembershipFileInfo(null)
        setLockerFileInfo(null)
        
        // 진행상황 초기화
        setUpdateProgress({
            isProcessing: false,
            totalCount: 0,
            completedCount: 0,
            currentFile: '',
            fileProgress: {
                member: { total: 0, completed: 0 },
                membership: { total: 0, completed: 0 },
                locker: { total: 0, completed: 0 }
            }
        })

        for (let i = 0; i < clubs.length; i++) {
            if(clubs[i].clubID == _clubid) {
                console.log('_resetClubInfo : ', clubs[i])
                setSelectClubInfo({
                    couponFlag:clubs[i].couponFlag,
                    couponPeriod:clubs[i].couponPeriod,
                    couponCount:clubs[i].couponCount,
                    couponRepeatCount:clubs[i].couponRepeatCount,
                    couponEditCount:0,
                    runningTrack:clubs[i].runningTrack,
                    kiosk:clubs[i].kiosk,
                    isEdit:false,
                    ...clubs[i]
                })
                break;
            }
        }
    }
    const setCouponFlag = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.couponFlag = value;
        _selectClubInfo.isEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }
    const setCouponPeriod = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.couponPeriod = value;
        _selectClubInfo.isEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }
    const setCouponRepeatCount = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.couponRepeatCount = value;
        _selectClubInfo.isEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }
    const setCouponEditCount = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.couponEditCount = value;
        setSelectClubInfo(_selectClubInfo)
    }

    const setCouponAdd = async (value)=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.post(`${url}/api/coupon/regist/${selectClub}?${queryString}`, {count:selectClubInfo.couponEditCount});
        console.log('setCouponAdd : ', res.data)

        if(res && res.data && res.data.result == 1) {
            alert('쿠폰 정보가 수정되었습니다.')
        }
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.couponCount = Number(_selectClubInfo.couponCount) + Number(selectClubInfo.couponEditCount)
        _selectClubInfo.couponEditCount = 0;
        setSelectClubInfo(_selectClubInfo)

        dispatch(
            loadAllClubList({
                playerID: Number(user.playerID),
                socketKey,
            }),
        );
    }

    const setChangeInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.post(`${url}/api/coupon/${selectClub}?${queryString}`, {repeatCount:selectClubInfo.couponRepeatCount, flag:selectClubInfo.couponFlag, period:selectClubInfo.couponPeriod});
        console.log('setChangeInfo : ', res.data)
        
        if(res && res.data && res.data.result == 1) {
            alert('쿠폰 정보가 수정되었습니다.')
        }

        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.isEdit = false;
        setSelectClubInfo(_selectClubInfo)

        dispatch(
            loadAllClubList({
                playerID: Number(user.playerID),
                socketKey,
            }),
        );
    }

    const setRunningTrackFlag = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.runningTrack = value;
        _selectClubInfo.isEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }
    const setChangeRunningTrackInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.post(`${url}/api/runningtrack/active/${selectClub}?${queryString}`, {runningTrack:selectClubInfo.runningTrack});
        console.log('setChangeRunningTrackInfo : ', res.data)
        
        if(res && res.data && res.data.result == 1) {
            if(selectClubInfo.runningTrack == 1) {
                alert('제타트랙이 활성화 되었습니다.')
            }
            else {
                alert('제타트랙 비활성화 되었습니다.')
            }
        }

        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.isEdit = false;
        setSelectClubInfo(_selectClubInfo)

        dispatch(
            loadAllClubList({
                playerID: Number(user.playerID),
                socketKey,
            }),
        );
    }

    const setStatus = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.clubStatus = value;
        _selectClubInfo.isStatusEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }

    const setKiosk = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.kiosk = value;
        _selectClubInfo.isKioskEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }

    const setDoorActiveFlag = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.attendActive = value;
        _selectClubInfo.isDoorEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }
    const setFaceActiveFlag = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.faceActive = value;
        _selectClubInfo.isDoorEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }
    const setQRActiveFlag = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.qrActive = value;
        _selectClubInfo.isDoorEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }
    const onChangeDoorInfos = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.clubDoorInfos = value;
        _selectClubInfo.isDoorEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }
    const onChangeDoorDeviceInfos = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.clubDoorDeviceInfos = value;
        _selectClubInfo.isDoorEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }

    const setChangeStatusInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.patch(`${url}/api/clubs/club/statusupdate/${selectClub}?${queryString}`, {clubStatus:selectClubInfo.clubStatus});
        console.log('setChangeStatusInfo : ', res.data)
        if(res && res.data && res.data.result == 1) {
            alert('활성화 정보가 수정되었습니다.')

            let _selectClubInfo = { ...selectClubInfo }
            _selectClubInfo.isStatusEdit = false;
            setSelectClubInfo(_selectClubInfo)
    
            dispatch(
                loadAllClubList({
                    playerID: Number(user.playerID),
                    socketKey,
                }),
            );
        }
        else {
            alert('활성화 정보 수정에 실패하였습니다.')
        }
    }

    const setChangeKioskInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.patch(`${url}/api/clubs/club/kioskupdate/${selectClub}?${queryString}`, {kiosk:selectClubInfo.kiosk});
        console.log('setChangeKioskInfo : ', res.data)
        if(res && res.data && res.data.result == 1) {
            alert('키오스크 정보가 수정되었습니다.')

            let _selectClubInfo = { ...selectClubInfo }
            _selectClubInfo.isStatusEdit = false;
            setSelectClubInfo(_selectClubInfo)

            dispatch(
                loadAllClubList({
                    playerID: Number(user.playerID),
                    socketKey,
                }),
            );
        }
    }

    const setClubType = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.clubStyle = value;
        _selectClubInfo.isClubTypeEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }

    const setChangeClubTypeInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.patch(`${url}/api/clubs/club/clubtypeupdate/${selectClub}?${queryString}`, {clubStyle:selectClubInfo.clubStyle});
        console.log('setChangeClubTypeInfo : ', res.data)
        if(res && res.data && res.data.result == 1) {
            alert('클럽 유형이 수정되었습니다.')

            let _selectClubInfo = { ...selectClubInfo }
            _selectClubInfo.isClubTypeEdit = false;
            setSelectClubInfo(_selectClubInfo)

            dispatch(
                loadAllClubList({
                    playerID: Number(user.playerID),
                    socketKey,
                }),
            );
        }
    }

    const setAttendAppActive = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.attendAppActive = value;
        _selectClubInfo.isAttendAppActiveEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }

    const setChangeAttendAppActiveInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.patch(`${url}/api/clubs/club/attendappupdate/${selectClub}?${queryString}`, {attendAppActive:selectClubInfo.attendAppActive});
        if(res && res.data && res.data.result == 1) {
            alert('출석앱 설정이 수정되었습니다.')

            let _selectClubInfo = { ...selectClubInfo }
            _selectClubInfo.isAttendAppActiveEdit = false;
            setSelectClubInfo(_selectClubInfo)

            dispatch(
                loadAllClubList({
                    playerID: Number(user.playerID),
                    socketKey,
                }),
            );
        }
        else {
            alert('출석앱 설정 수정에 실패하였습니다.')
        }
    }

    // 바코드 스캔모드: 0 회원 스캐너(기본) / 1 미사용 / 2 출석기
    const setBarcodeMode = (value)=>{
        let _selectClubInfo = { ...selectClubInfo }
        _selectClubInfo.barcodeMode = value;
        _selectClubInfo.isBarcodeModeEdit = true;
        setSelectClubInfo(_selectClubInfo)
    }

    const setChangeBarcodeModeInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        let res = await client.patch(`${url}/api/clubs/club/barcodemodeupdate/${selectClub}?${queryString}`, {barcodeMode:selectClubInfo.barcodeMode});
        if(res && res.data && res.data.result == 1) {
            alert('바코드 스캔모드가 수정되었습니다.')

            let _selectClubInfo = { ...selectClubInfo }
            _selectClubInfo.isBarcodeModeEdit = false;
            setSelectClubInfo(_selectClubInfo)

            dispatch(
                loadAllClubList({
                    playerID: Number(user.playerID),
                    socketKey,
                }),
            );
        }
        else {
            alert('바코드 스캔모드 수정에 실패하였습니다.')
        }
    }

    const setChangeDoorInfo = async ()=>{
        const queryString = qs.stringify({
            socketKey,
        });
        
        const msg = {
            attendActive:selectClubInfo.attendActive,
            faceActive:selectClubInfo.faceActive,
            qrActive:selectClubInfo.qrActive,
            clubDoorDeviceInfos:selectClubInfo.clubDoorDeviceInfos,
            clubDoorInfos:selectClubInfo.clubDoorInfos,
        }

        let res = await client.patch(`${url}/api/clubs/club/doorupdate/${selectClub}?${queryString}`, msg);
        console.log('setChangeDoorInfo : ', res.data)
        if(res && res.data && res.data.result == 1) {
            alert('출입문 정보가 수정되었습니다.')

            let _selectClubInfo = { ...selectClubInfo }
            _selectClubInfo.isDoorEdit = false;
            setSelectClubInfo(_selectClubInfo)
    
            dispatch(
                loadAllClubList({
                    playerID: Number(user.playerID),
                    socketKey,
                }),
            );
        }
        else {
            alert('출입문 정보 수정에 실패하였습니다.')
        }
    }

    // CSV 파싱 함수 (쉼표, 따옴표 처리)
    const parseCSVLine = (line) => {
        const result = [];
        let current = '';
        let inQuotes = false;
        
        for (let i = 0; i < line.length; i++) {
            const char = line[i];
            
            if (char === '"') {
                if (inQuotes && line[i + 1] === '"') {
                    current += '"';
                    i++; // 다음 따옴표 건너뛰기
                } else {
                    inQuotes = !inQuotes;
                }
            } else if (char === ',' && !inQuotes) {
                result.push(current.trim());
                current = '';
            } else {
                current += char;
            }
        }
        
        result.push(current.trim());
        return result;
    };

    // 인코딩 감지 및 변환 함수
    const detectAndConvertEncoding = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const arrayBuffer = e.target.result;
                    const bytes = new Uint8Array(arrayBuffer);
                    
                    // UTF-8 BOM 체크
                    if (bytes.length >= 3 && bytes[0] === 0xEF && bytes[1] === 0xBB && bytes[2] === 0xBF) {
                        const text = new TextDecoder('utf-8').decode(bytes.slice(3));
                        resolve(text);
                        return;
                    }
                    
                    // EUC-KR 시도
                    try {
                        const text = new TextDecoder('euc-kr').decode(bytes);
                        // 한글이 제대로 디코딩되었는지 확인
                        if (text.includes('회원') || text.includes('이름') || text.includes('전화')) {
                            resolve(text);
                            return;
                        }
                    } catch (e) {
                        console.log('EUC-KR 디코딩 실패');
                    }
                    
                    // CP949 시도
                    try {
                        const text = new TextDecoder('cp949').decode(bytes);
                        if (text.includes('회원') || text.includes('이름') || text.includes('전화')) {
                            resolve(text);
                            return;
                        }
                    } catch (e) {
                        console.log('CP949 디코딩 실패');
                    }
                    
                    // UTF-8 시도
                    try {
                        const text = new TextDecoder('utf-8').decode(bytes);
                        resolve(text);
                    } catch (e) {
                        // 마지막 수단: 기본 디코딩
                        const text = new TextDecoder().decode(bytes);
                        resolve(text);
                    }
                } catch (error) {
                    reject(error);
                }
            };
            reader.onerror = () => reject(new Error('파일 읽기 실패'));
            reader.readAsArrayBuffer(file);
        });
    };

    // CSV 파일 읽기 함수 (강력한 인코딩 문제 해결)
    const readCSVFile = async (file) => {
        try {
            const text = await detectAndConvertEncoding(file);
            
            // 줄바꿈 정규화 (Windows \r\n, Mac \r, Unix \n)
            const normalizedText = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            const lines = normalizedText.split('\n').filter(line => line.trim() !== '');
            
            if (lines.length === 0) {
                return { count: 0, headers: [], data: [] };
            }

            // 첫 번째 줄을 헤더로 처리 (정교한 파싱 사용)
            const originalHeaders = parseCSVLine(lines[0]);
            console.log('원본 CSV 헤더:', originalHeaders);
            
            // 깨진 헤더 수정
            const headers = fixBrokenHeaders(originalHeaders);
            console.log('수정된 CSV 헤더:', headers);
            
            // 나머지 줄들을 데이터로 처리
            const data = [];
            for (let i = 1; i < lines.length; i++) {
                const values = parseCSVLine(lines[i]);
                const rowData = {};
                
                // 헤더와 값을 매핑하여 객체 생성
                headers.forEach((header, index) => {
                    rowData[header] = values[index] || '';
                });
                
                data.push(rowData);
            }
            
            console.log('CSV 데이터 샘플:', data[0]);
            
            return {
                count: data.length,
                headers: headers,
                data: data
            };
        } catch (error) {
            throw new Error('CSV 파싱 실패: ' + error.message);
        }
    };

    // CSV 헤더/키 정규화
    const normalizeKey = (key) => {
        if (!key) return '';
        return String(key)
            .toLowerCase()
            .replace(/\s+/g, '')
            .replace(/[_-]+/g, '')
            .replace(/[()\[\]\u00A0]/g, '');
    };

    // 깨진 한글 컬럼명을 올바른 이름으로 매핑
    const fixBrokenHeaders = (headers) => {
        const headerMap = {
            // 회원 관련
            'ȸε': '회원아이디',
            'ȸ': '회원명',
            '': '비밀번호',
            '̵': '아이디',
            '': '성별',
            'ó': '연락처',
            '': '생년월일',
            
            // 회원권 관련
            'ȸȸ': '회원권명',
            '': '회원권이름',
            'ǥ': '상품명',
            '': '가격',
            '': '금액',
            '': '결제금액',
            '': '시작일',
            '': '종료일',
            '': '판매일',
            'ȸ': '횟수',
            
            // 락커 관련
            'ġȣ': '락커번호',
            'ȣ': '사물함번호',
            '': '보증금',
            
            // 기타
            'ް': '메모',
            '': '메모',
            '': '카테고리',
            'ȣ': '번호',
            '': '코드'
        };

        return headers.map(header => {
            // 깨진 문자 패턴 체크
            if (header.includes('') || header.includes('ȸ') || header.includes('')) {
                return headerMap[header] || header;
            }
            return header;
        });
    };

    // 행 데이터에서 다양한 컬럼 명 변형을 안전하게 찾기
    const pickValue = (row, candidates) => {
        const normalizedMap = {};
        Object.keys(row).forEach((k) => {
            normalizedMap[normalizeKey(k)] = row[k];
        });
        for (let i = 0; i < candidates.length; i++) {
            const key = normalizeKey(candidates[i]);
            if (normalizedMap.hasOwnProperty(key)) return normalizedMap[key];
        }
        return '';
    };

    // 타입별 페이로드 빌더 (임시 스키마: 서버 요구사항에 맞춰 쉽게 확장 가능)
    const payloadBuilders = {
        member: (row) => ({
            name: pickValue(row, ['name', '이름', '회원명']),
            phone: pickValue(row, ['phone', 'mobile', '전화번호', '연락처']),
            birth: pickValue(row, ['birth', 'birthday', '생년월일', '생일']),
            gender: pickValue(row, ['gender', '성별']),
            id: pickValue(row, ['id', 'account', '계정', '아이디']),
            password: pickValue(row, ['password', '비밀번호', '비번']),
            memberID: pickValue(row, ['memberid', '회원아이디', '회원인덱스']),
        }),
        membership: (row) => ({
            name: pickValue(row, ['name', '이름', '회원명']),
            phone: pickValue(row, ['phone', 'mobile', '전화번호', '연락처']),
            birth: pickValue(row, ['birth', 'birthday', '생년월일', '생일']),
            gender: pickValue(row, ['gender', '성별']),
            membershipName: pickValue(row, ['membershipName', '상품명', '회원권명', '회원권 이름']),
            registDate: pickValue(row, ['registdate', '판매일']),
            startDate: pickValue(row, ['startdate', '시작일']),
            endDate: pickValue(row, ['enddate', '종료일']),
            count: pickValue(row, ['count', '횟수']),
            price: pickValue(row, ['price', '가격', '금액', '결제금액'])
        }),
        locker: (row) => ({
            name: pickValue(row, ['name', '이름', '회원명']),
            phone: pickValue(row, ['phone', 'mobile', '전화번호', '연락처']),
            birth: pickValue(row, ['birth', 'birthday', '생년월일', '생일']),
            gender: pickValue(row, ['gender', '성별']),
            lockerName: pickValue(row, ['lockername', '락커구역', '사물함구역']),
            lockerNo: pickValue(row, ['lockerno', '락커번호', '사물함번호']),
            password: pickValue(row, ['password', '비밀번호', '비번']),
            startDate: pickValue(row, ['startdate', '시작일']),
            endDate: pickValue(row, ['enddate', '종료일']),
            price: pickValue(row, ['price', '가격', '금액', '결제금액']),
        })
    };

    const buildPayloadByType = (type, row) => {
        const builder = payloadBuilders[type];
        if (!builder) return row; // 알 수 없는 타입은 원본 전달
        return builder(row);
    };

    // 회원 등록 및 playerID 저장
    const registerMemberAndGetPlayerID = async (memberData) => {
        try {
            let memberID = null
            if(!memberData.memberID || memberData.memberID == '' || memberData.memberID == '0') {
                // 19000101 형식으로 변환
                let _birth = memberData.birth
                _birth = _birth.replace(/-/gi, '')
                let _gender = memberData.gender == '남성'? 1 : 2
    
                console.log('registerMemberAndGetPlayerID memberData : ', {
                    account: memberData.id,
                    birth: _birth,
                    name: memberData.name,
                    password: memberData.password,
                    phone: memberData.phone,
                    gender: _gender,
                    height: 170,
                    weight: 70,
                    socketKey,
                    clubID: selectClub,
                })
                const response = await clubMemberRegist({
                    account: memberData.id,
                    birth: _birth,
                    name: memberData.name,
                    password: memberData.password,
                    phone: memberData.phone,
                    gender: _gender,
                    height: 170,
                    weight: 70,
                    socketKey,
                    clubID: selectClub,
                });
                if (response && response.data && response.data.result === 1) {
                    memberID = response.data.playerID;
                } else {
                    console.error('회원 등록 실패:', response.data);
                    return null;
                }
            }
            else {
                memberID = memberData.memberID;
            }

            if(memberID) {
                const changePasswordResponse = await changePassword({
                    account: memberData.id,
                    password: memberData.password,
                    targetID: memberID,
                    socketKey,
                });
            }
            
            return memberID;
        } catch (error) {
            console.error('회원 등록 중 오류:', error);
            return null;
        }
    };

    // 회원 찾기 (name, phone으로 매칭)
    const findMemberByInfo = (name, phone, gender, memberMap) => {
        const key = `${name}_${phone}_${gender}`;
        return memberMap.get(key);
    };

    // 아이템에서 회원권 이름으로 매칭
    const findItemByName = (membershipName, itemDataList) => {
        if (!itemDataList || itemDataList.length === 0) return null;
        
        // 정확한 이름 매칭 시도
        let item = itemDataList.find(item => 
            item.title === membershipName || 
            item.name === membershipName
        );
        
        if (item) return item;
        
        // 부분 매칭 시도 (대소문자 무시)
        item = itemDataList.find(item => 
            item.title?.toLowerCase().includes(membershipName.toLowerCase()) ||
            item.name?.toLowerCase().includes(membershipName.toLowerCase()) ||
            membershipName.toLowerCase().includes(item.title?.toLowerCase()) ||
            membershipName.toLowerCase().includes(item.name?.toLowerCase())
        );
        
        return item || null;
    };

    // 락커 데이터에서 name과 lockerSN으로 매칭
    const findLockerByNameAndSN = (lockerName, lockerNo, lockerDataList) => {
        if (!lockerDataList || lockerDataList.length === 0) return null;
        
        // 정확한 매칭 시도
        let locker = lockerDataList.find(locker => 
            locker.name === lockerName && 
            locker.lockerSN === Number(lockerNo)
        );
        
        if (locker) return locker;
        
        // 부분 매칭 시도 (대소문자 무시)
        locker = lockerDataList.find(locker => 
            (locker.name?.toLowerCase().includes(lockerName.toLowerCase()) ||
             lockerName.toLowerCase().includes(locker.name?.toLowerCase())) &&
            locker.lockerSN === Number(lockerNo)
        );
        
        return locker || null;
    };

    // 딜레이 함수
    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    // CSV 파일 일괄 업로드 처리
    const onSaveData = async () => {
        const queryString = qs.stringify({
            socketKey,
        });

        try {

            // 처리할 파일들 수집
            const filesToProcess = [];
            if (memberFileInfo) filesToProcess.push({ file: memberFileInfo, type: 'member', name: '회원 목록' });
            if (membershipFileInfo) filesToProcess.push({ file: membershipFileInfo, type: 'membership', name: '회원권 목록' });
            if (lockerFileInfo) filesToProcess.push({ file: lockerFileInfo, type: 'locker', name: '락커 목록' });

            if (filesToProcess.length === 0) {
                alert('업로드할 파일이 없습니다.');
                return;
            }

            // 1단계: 각 CSV 파일의 데이터 읽기 및 갯수 파악
            setUpdateProgress(prev => ({ ...prev, isProcessing: true, currentFile: '데이터 분석 중...' }));
            
            let totalCount = 0;
            const fileData = {};
            
            for (const { file, type } of filesToProcess) {
                const csvData = await readCSVFile(file);
                fileData[type] = csvData;
                totalCount += csvData.count;
                
                setUpdateProgress(prev => ({
                    ...prev,
                    fileProgress: {
                        ...prev.fileProgress,
                        [type]: { total: csvData.count, completed: 0 }
                    }
                }));
            }

            // 총 갯수 업데이트
            setUpdateProgress(prev => ({ ...prev, totalCount, completedCount: 0 }));

            // 2단계: 순차 처리 - member 먼저, 그 다음 나머지 타입들
            let completedCount = 0;
            const memberMap = new Map(); // name_phone -> playerID 매핑
            
            // 2-1: member 타입 먼저 처리
            if (fileData.member && fileData.member.count > 0) {
                setUpdateProgress(prev => ({ ...prev, currentFile: '회원 목록 처리 중...' }));
                
                for (let i = 0; i < fileData.member.data.length; i++) {
                    const rowData = fileData.member.data[i];
                    const memberData = buildPayloadByType('member', rowData);
                    console.log('onSaveData memberData : ', memberData, rowData)
                    try {
                        const playerID = await registerMemberAndGetPlayerID(memberData);
                        
                        if (playerID) {
                            // 회원 등록 성공 시 매핑 저장
                            const key = `${memberData.name}_${memberData.phone}_${memberData.gender}`;
                            memberMap.set(key, playerID);
                            completedCount++;
                            
                            setUpdateProgress(prev => ({
                                ...prev,
                                completedCount,
                                fileProgress: {
                                    ...prev.fileProgress,
                                    member: { 
                                        total: fileData.member.count, 
                                        completed: prev.fileProgress.member.completed + 1 
                                    }
                                }
                            }));
                        } else {
                            alert(`회원 등록 실패 - 행 ${i+1}`);
                            console.error(`회원 등록 실패 - 행 ${i+1}:`, memberData);
                            break;
                        }
                    } catch (error) {
                        alert(`회원 등록 중 오류 - 행 ${i+1}`);
                        console.error(`회원 등록 중 오류 - 행 ${i+1}:`, error);
                        break;
                    }
                    
                    await delay(300);
                }
            }

            // 2-2: membership 타입 처리
            if (fileData.membership && fileData.membership.count > 0) {
                setUpdateProgress(prev => ({ ...prev, currentFile: '회원권 목록 처리 중...' }));
                
                //--> 아이템 불러오기
                let itemresult = await list({clubID: selectClub, socketKey})

                let itemDataList = []
                if(itemresult && itemresult.data && itemresult.data.result === 1) {
                    itemDataList = itemresult.data.infos
                }
                for (let i = 0; i < fileData.membership.data.length; i++) {
                    const rowData = fileData.membership.data[i];
                    const payload = buildPayloadByType("membership", rowData);

                    try {
                        // 해당 회원의 playerID 찾기
                        const playerID = findMemberByInfo(payload.name, payload.phone, payload.gender, memberMap);
                        
                        if (!playerID) {
                            console.warn(`membership 행 ${i+1}: 회원권을 찾을 수 없음 (${payload.name}, ${payload.phone})`);
                            continue;
                        }
                        // 아이템에서 회원권 찾기
                        const matchedItem = findItemByName(payload.membershipName, itemDataList);
                        
                        if (!matchedItem) {
                            console.warn(`membership 행 ${i+1}: 회원권을 찾을 수 없음 (${payload.membershipName})`);
                            continue;
                        }


                        const clubMembershipData = {
                            clubMembershipID: '',
                            currentCount: 0,
                            registTime: Math.ceil(new Date(payload.registDate).setHours(0, 0, 0, 0) / 1000),
                            startTime: Math.ceil(new Date(payload.startDate).setHours(0, 0, 0, 0) / 1000),
                            endTime: Math.ceil(new Date(payload.endDate).setHours(23, 59, 59, 0) / 1000),
                            playerID: playerID,
                            playerName: payload.name,
                            title: payload.membershipName,
                            totalCount: parseInt(payload.count) || matchedItem.count || 0,
                            type: matchedItem.type || 1,
                            salePrice: parseInt(payload.price) || matchedItem.price || 0,
                            price: parseInt(payload.price) || matchedItem.price || 0,
                            state: 1,
                            card: 0,
                            card2: 0,
                            company: "",
                            authNumber: "",
                            InstallmentMonth: "",
                            company2: "",
                            authNumber2: "",
                            InstallmentMonth2: "",
                            cash: parseInt(payload.price) || matchedItem.price || 0,
                            pay: 0,
                            point: 0,
                            category: matchedItem.category || 0,
                            unpayment: 0,
                            isNew: 1,
                            refundPrice: 0,
                            refundTime: 0,
                            refundReason: "",
                            clubItemID: matchedItem.ClubItemID,
                            ptID: "",
                            totalCancelCount: matchedItem.totalCancelCount || 0,
                            lessonTime: matchedItem.lessonTime || 0,
                            countLinkFlag: matchedItem.countLinkFlag || 0,
                            lessonType: matchedItem.lessonType || 0,
                            holdList: [],
                            controlList: [],
                            coaches: [],
                            paymentID: "",
                            subscriptionID: ""
                        };

                        const response = await saleMembership({
                            clubMembershipData: clubMembershipData,
                            clubID: selectClub,
                            socketKey,
                        });

                        if (response && response.data && response.data.result === 1) {
                            completedCount++;
                            
                            setUpdateProgress(prev => ({
                                ...prev,
                                completedCount,
                                fileProgress: {
                                    ...prev.fileProgress,
                                    ["membership"]: { 
                                        total: fileData.membership.count, 
                                        completed: prev.fileProgress["membership"].completed + 1 
                                    }
                                }
                            }));
                        } else {
                            console.error(`membership 행 ${i+1} 처리 실패:`, response.data);
                        }

                        await delay(5000);
                    } catch (error) {
                        console.error(`membership 행 ${i+1} 처리 중 오류:`, error);
                    }
                }

            }
            
             if(fileData.locker && fileData.locker.count > 0) {
                 setUpdateProgress(prev => ({ ...prev, currentFile: '락커 목록 처리 중...' }));
                 
                 let lockerresult = await readClubLocker({clubID: selectClub, socketKey})
                 let lockerDataList = []
                 if(lockerresult && lockerresult.data && lockerresult.data.result === 1) {
                     lockerDataList = lockerresult.data.infos
                 }
                 console.log('lockerDataList : ', lockerDataList)
                 
                 for (let i = 0; i < fileData.locker.data.length; i++) {
                     const rowData = fileData.locker.data[i];
                     const payload = buildPayloadByType("locker", rowData);

                     try {
                        if(payload.lockerNo == '-') {
                            continue;
                        }
                        
                         // 해당 회원의 playerID 찾기
                         const playerID = findMemberByInfo(payload.name, payload.phone, payload.gender, memberMap);
                         
                         if (!playerID) {
                             console.warn(`locker 행 ${i+1}: 회원을 찾을 수 없음 (${payload.name}, ${payload.phone})`);
                             continue;
                         }

                         // 락커 데이터에서 매칭하는 락커 찾기
                         const matchedLocker = findLockerByNameAndSN(payload.lockerName, payload.lockerNo, lockerDataList);
                         
                         console.log('matchedLocker : ', payload.lockerName, payload.lockerNo, matchedLocker)
                         if (!matchedLocker) {
                             console.warn(`locker 행 ${i+1}: 락커를 찾을 수 없음 (${payload.lockerName}, ${payload.lockerNo})`);
                             continue;
                         }

                         let clubLockUserData = {
                             clubUserLockerID: '',
                             clubItemID: "",
                             lockerID: matchedLocker.lockerID,
                             card: 0,
                             card2: 0,
                             company: "",
                             company2: "",
                             authNumber: "",
                             authNumber2: "",
                             InstallmentMonth: "",
                             InstallmentMonth2: "",
                             cash: Number(payload.price),
                             point: 0,
                             pay: 0,
                             salePrice: Number(payload.price),
                             price: Number(payload.price),
                             category: 100,
                             state: 1,
                             holdList: [],
                             controlList: [],
                             playerID: Number(playerID),
                             playerName: payload.name,
                             phone: payload.phone,
                             name: `${payload.lockerName} ${matchedLocker.lockerSN}`,
                             type: 100,
                             registTime: Math.ceil(new Date(payload.startDate).setHours(0, 0, 0, 0) / 1000),
                             startTime: Math.ceil(new Date(payload.startDate).setHours(0, 0, 0, 0) / 1000),
                             endTime: Math.ceil(new Date(payload.endDate).setHours(23, 59, 59, 0) / 1000),
                             unpayment: 0,
                             password: payload.password,
                             isNew: 1,
                             subsID: "",
                         };

                         //console.log('clubLockUserData : ', clubLockUserData)
                         const response = await addClubUserLocker({
                             clubID: selectClub,
                             clubLockUserData: clubLockUserData,
                             isNew: 1,
                             lockerID: matchedLocker.lockerID,
                             socketKey,
                         });

                         if (response && response.data && response.data.result === 1) {
                             completedCount++;
                             
                             setUpdateProgress(prev => ({
                                 ...prev,
                                 completedCount,
                                 fileProgress: {
                                     ...prev.fileProgress,
                                     ["locker"]: { 
                                         total: fileData.locker.count, 
                                         completed: prev.fileProgress["locker"].completed + 1 
                                     }
                                 }
                             }));
                         } else {
                             console.error(`locker 행 ${i+1} 처리 실패:`, response.data);
                         }

                         await delay(100);
                     } catch (error) {
                         console.error(`locker 행 ${i+1} 처리 중 오류:`, error);
                     }
                 }
             }

            // 3단계: 완료 처리
            setUpdateProgress(prev => ({ 
                ...prev, 
                currentFile: '처리 완료',
                isProcessing: false 
            }));

            alert('모든 데이터가 성공적으로 업로드되었습니다.');
            
            // 파일 상태 초기화
            setMemberFileInfo(null);
            setMembershipFileInfo(null);
            setLockerFileInfo(null);

            // 진행상황 초기화
            setUpdateProgress({
                isProcessing: false,
                totalCount: 0,
                completedCount: 0,
                currentFile: '',
                fileProgress: {
                    member: { total: 0, completed: 0 },
                    membership: { total: 0, completed: 0 },
                    locker: { total: 0, completed: 0 }
                }
            });

            // 클럽 목록 새로고침
            dispatch(
                loadAllClubList({
                    playerID: Number(user.playerID),
                    socketKey,
                }),
            );

        } catch (error) {
            console.error('CSV 파일 업로드 에러:', error);
            setUpdateProgress(prev => ({ 
                ...prev, 
                isProcessing: false,
                currentFile: '처리 실패'
            }));
            alert('데이터 업로드 중 오류가 발생했습니다.');
        }
    };

    const onTempUpdate = async () => {
        // setUpdateProgress(prev => ({ ...prev, isProcessing: true, currentFile: '회원 불러오는 중...' }));
        
        // let memberDataList = []
        // for(let i = 1; i <= 19; i++) {
        //     let result = await loadClubMemberList({clubID: selectClub, socketKey, page: i, searchText: '', type: 'registTime', socketKey})
        //     if(result && result.data && result.data.result === 1) {
        //         for(let j = 0; j < result.data.infos.length; j++) {
        //             let memberData = result.data.infos[j]
        //             memberDataList.push(memberData)
        //         }
        //     }
        // }
        // setUpdateProgress(prev => ({ ...prev, totalCount: memberDataList.length, completedCount: 0 }));

        // //--> 아이템 불러오기
        // let itemresult = await list({clubID: selectClub, socketKey})

        // let itemDataList = []
        // if(itemresult && itemresult.data && itemresult.data.result === 1) {
        //     itemDataList = itemresult.data.infos
        // }

        // let completedCount = 0
        
        // try {
        //     for(let i = 0; i < memberDataList.length; i++) {
        //         let playerID = memberDataList[i].playerID
        //         // if(memberDataList[i].name != "황재민") {
        //         //     continue;
        //         // }

        //         let result = await read_membership({clubID: selectClub, targetID: playerID, socketKey})

        //         if(result && result.data && result.data.membership && result.data.membership.infos && result.data.membership.infos.length > 0) {
        //             for(let j = 0; j < result.data.membership.infos.length; j++) {
        //                 let membershipData = result.data.membership.infos[j]

        //                 console.log('membershipData : ', membershipData.clubItemID)
        //                 if(membershipData && membershipData.clubItemID == "") {
        //                     let matchedItem = findItemByName(membershipData.title, itemDataList)
        //                     if(matchedItem) {
        //                         membershipData.clubItemID = matchedItem.ClubItemID
        //                         console.log('change membershipData : ', membershipData.clubItemID)
        //                         await updateMembership({ clubMembershipData: membershipData, clubID:selectClub, socketKey })
        //                         await delay(5000)
        //                     }
        //                 }
        //                 //await delay(5000)
        //             }
        //         }
        //         completedCount++
        //         setUpdateProgress(prev => ({ ...prev, completedCount: completedCount }));
        //     }
        // } catch (error) {
        //     console.error('회원권 업데이트 중 오류:', error);
        // }
        // console.log('memberDataList : ', memberDataList, itemDataList)
        // setUpdateProgress(prev => ({ ...prev, isProcessing: false, currentFile: '' }));
    }

    const onClickTest = async ()=>{
        // let res = await client.post(`${url}/api/kiosk/auth/phone`, {phoneNumber:'01043487701'});
        // console.log('onClickTest : ', res)
        // if(res && res.data && res.data.result == 1) {
        //     alert(`본인인증 번호가 발송되었습니다. ${res.data.code}`)
        // }
        // else {
        // }
        

        // let res = await client.get(`${url}/api/kiosk/club/load/123456`);

        // console.log('onClickTest : ', res)


        // let res = await client.post(`${url}/api/kiosk/member/regist`, {birth: 19900101, clubID: 1, name: '홍길동', phone: '010-1234-5679', sex: 1});
        // console.log('onClickTest : ', res)

        // console.log('url : ', `${url}/api/kiosk/club/econtract/1`)
        // let res = await client.get(`${url}/api/kiosk/club/econtract/1`);
        // console.log('onClickTest : ', res)
        // if(res && res.data && res.data.result === 1) {
        //     console.log('eContractInfo : ', res.data.eContractInfo)
        // }
        // else {
        //     console.log('eContractInfo error : ', res.data)
        // }

        // try {
        //     console.log('onClickTest : 11111')
        //     let res1 = await client.get(`${url}/api/kiosk/product/list/1`);
        //     let product = null
        //     if(res1 && res1.data && res1.data.result === 'SUCCESS') {
        //         product = res1.data.infos[0]
        //     }

        //     console.log('onClickTest : 22222 ', product, res1.data)
        //     let registTime = Math.ceil(Date.now() / 1000)
        //     let tempDate = new Date()
        //     tempDate.setHours(0, 0, 0, 0)
        //     let startTime = Math.ceil(tempDate.getTime() / 1000)
        //     tempDate.setDate(tempDate.getDate() + 10)
        //     tempDate.setHours(23, 59, 59, 999)
        //     let endTime = Math.ceil(tempDate.getTime() / 1000)
        //     const clubKioskSalesItemData = {
        //         clubKioskSalesItemData: product,
        //         playerID: 31588,
        //         playerName: '홍길동',
        //         price: 10000,
        //         cardName: '카드1',
        //         cardNumber: '1234567890',
        //         approvalNumber: '1234567890',
        //         approvalDateTime: '20260101120000',
        //         startTime: startTime,
        //         endTime: endTime,
        //         registTime: registTime,
        //         usePoint: 0,
        //         card: 5000,
        //         pay: 5000,
        //     }
        //     let res = await client.post(`${url}/api/kiosk/payment/1`, clubKioskSalesItemData);
        //     console.log('onClickTest : 33333')
        //     console.log('onClickTest : ', res)
        // } catch (error) {
        //     console.error('onClickTest error : ', error)
        // }


        // try {
        //     let res = await client.delete(`${url}/api/kiosk/payment/1/${'b33a7bdf-00d0-4cbf-b7fd-31be941fe947'}`);
        //     console.log('onClickTest : ', res)
        //     if(res && res.data && res.data.result === 1) {
        //         alert('결제 삭제 완료')
        //     }
        //     else {
        //         alert('결제 삭제 실패')
        //     }
        // } catch (error) {
        //     console.error('onClickTest error : ', error)
        // }
        // 'b33a7bdf-00d0-4cbf-b7fd-31be941fe947','20260101120000','1234567890','카드1','1234567890','1','43473ca6-146f-4f83-83e5-10f3760e7040','4b7d287e-8ab9-4720-9395-6e39020271fc','31588','홍길동','10000',NULL
        // 'bc84bc1e-712b-49d1-b8c6-ff1c1b661dbe','20260101120000','1234567890','카드1','1234567890','1','43473ca6-146f-4f83-83e5-10f3760e7040','2b6b97a6-f815-4f36-b054-8384a9689b71','31588','홍길동','10000',NULL
        // 'bf73d048-c01c-40d3-b85f-30109af0a9e7','20260101120000','1234567890','카드1','1234567890','1','43473ca6-146f-4f83-83e5-10f3760e7040','6b8d044c-af75-46e1-b06d-8d8837a5629a','31588','홍길동','10000',NULL

        
        // let res = await client.get(`${url}/api/kiosk/product/list/1`);
        // console.log('onClickTest : ', res)
        // if(res && res.data && res.data.result === 1) {
        //     console.log('productList : ', res.data.productList)
        // }
        // else {
        //     console.log('productList error : ', res.data)
        // }
    }

    return (
        <>
            <ClubSelectItem
                clubList={clubList}
                selectClub={selectClub}
                setSelectClub={setSelectClub}
                onAddClick={() => setClubCreateModalOpen(true)}
            />
            <ClubCreateModal
                open={clubCreateModalOpen}
                onClose={() => setClubCreateModalOpen(false)}
                socketKey={socketKey}
                user={user}
                onSuccess={() => {
                    dispatch(loadAllClubList({
                        playerID: Number(user?.playerID),
                        socketKey,
                    }));
                }}
            />
            <SettingsLayout>
            <AdminClubStatusInfo
                selectClubInfo={selectClubInfo}
                setStatus={setStatus}
                setChangeStatusInfo={setChangeStatusInfo}
            />
            <AdminClubRegistNumberInfo
                selectClubInfo={selectClubInfo}
                selectClub={selectClub}
                socketKey={socketKey}
                onSuccess={() => {
                    dispatch(loadAllClubList({
                        playerID: Number(user.playerID),
                        socketKey,
                    }));
                }}
            />
            <AdminClubAttendAppInfo
                selectClubInfo={selectClubInfo}
                setAttendAppActive={setAttendAppActive}
                setChangeAttendAppActiveInfo={setChangeAttendAppActiveInfo}
            />
            <AdminClubTypeInfo
                selectClubInfo={selectClubInfo}
                setClubType={setClubType}
                setChangeClubTypeInfo={setChangeClubTypeInfo}
            />
            <AdminClubKioskInfo
                selectClubInfo={selectClubInfo}
                setKiosk={setKiosk}
                setChangeKioskInfo={setChangeKioskInfo}
            />
            {/* <button onClick={() => onClickTest()} style={{backgroundColor: '#121212', color:'#fff', border: '1px solid rgba(0, 0, 0, .2)', borderRadius: '.2rem', padding: '10px 20px', cursor: 'pointer', fontSize: '1.2rem'}}>test</button> */}
            <AdminClubDoorInfo
                selectClubInfo={selectClubInfo}
                setDoorActiveFlag={setDoorActiveFlag}
                setFaceActiveFlag={setFaceActiveFlag}
                setQRActiveFlag={setQRActiveFlag}
                setChangeDoorInfo={setChangeDoorInfo}
                onChangeDoorInfos={onChangeDoorInfos}
                onChangeDoorDeviceInfos={onChangeDoorDeviceInfos}
                socketKey={socketKey}
            />
            <AdminClubRunningTrack
                selectClubInfo={selectClubInfo}
                setRunningTrackFlag={setRunningTrackFlag}
                setChangeRunningTrackInfo={setChangeRunningTrackInfo}
            />
            <AdminClubCoupon
                selectClubInfo={selectClubInfo}
                setCouponFlag={setCouponFlag}
                setCouponPeriod={setCouponPeriod}
                setCouponRepeatCount={setCouponRepeatCount}
                setCouponEditCount={setCouponEditCount}

                setCouponAdd={setCouponAdd}
                setChangeInfo={setChangeInfo}
            />
            <AdminClubBarcode
                selectClubInfo={selectClubInfo}
                setBarcodeMode={setBarcodeMode}
                setChangeBarcodeModeInfo={setChangeBarcodeModeInfo}
            />
            <AdminClubDataInfo
                selectClubInfo={selectClubInfo}
                memberFileInfo={memberFileInfo}
                setMemberFileInfo={setMemberFileInfo}
                membershipFileInfo={membershipFileInfo}
                setMembershipFileInfo={setMembershipFileInfo}
                lockerFileInfo={lockerFileInfo}
                setLockerFileInfo={setLockerFileInfo}
                onSaveData={onSaveData}
                onTempUpdate={onTempUpdate}
                updateProgress={updateProgress}
            />
            </SettingsLayout>
        </>
    );
};

export default AdminClubSettingContainer;
